import React from 'react';
import Table, { TableRow, TableHeading, TableBody, TableCell } from '../../table/Table';

const HeadlinePerformance = ({ dataset }) => (
  <Table>
    <TableHeading>
      <TableCell as="th" fill strong>
        Day
      </TableCell>
      <TableCell as="th" fill strong>
        Uptime mobile (%)
      </TableCell>
      <TableCell as="th" fill strong>
        Downtime mobile (%)
      </TableCell>
      <TableCell as="th" fill strong>
        Uptime dedicated (%)
      </TableCell>
      <TableCell as="th" fill strong>
        Downtime dedicated (%)
      </TableCell>
      <TableCell as="th" fill strong>
        Error rate dedicated (%)
      </TableCell>
    </TableHeading>
    <TableBody>
      {dataset.map((item) => (
        <TableRow key={`availability_${item.day}`}>
          <TableCell as="th" fill strong>
            {item.day}
          </TableCell>
          <TableCell>{item.mobileUptime}</TableCell>
          <TableCell>{item.mobileDowntime}</TableCell>
          <TableCell>{item.partnerUptime}</TableCell>
          <TableCell>{item.partnerDowntime}</TableCell>
          <TableCell>{item.errorRate}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default HeadlinePerformance;
